export var horoscopeTimeList = {
  Capricorn: 'Dec 12 - Jan 19',
  Aquarius: 'Jan 20 - Feb 18',
  Pisces: 'Feb 19 - Mar 20',
  Aries: 'Mar 21 - Apr 19',
  Taurus: 'Apr 20 - May 20',
  Gemini: 'May 21 - June 21',
  Cancer: 'June 22 - July 22',
  Leo: 'July 23 - Aug 22',
  Virgo: 'Aug 23 - Sept 22',
  Libra: 'Sept 23 - Oct 23',
  Scorpio: 'Oct 24 - Nov 22',
  Sagittarius: 'Nov 23 - Dec 21'
};
export var horoscopeIdex = {
  Aries: 1,
  Taurus: 2,
  Gemini: 3,
  Cancer: 4,
  Leo: 5,
  Virgo: 6,
  Libra: 7,
  Scorpio: 8,
  Sagittarius: 9,
  Capricorn: 10,
  Aquarius: 11,
  Pisces: 12
};
export var horoscopeName = {
  1: 'Aries',
  2: 'Taurus',
  3: 'Gemini',
  4: 'Cancer',
  5: 'Leo',
  6: 'Virgo',
  7: 'Libra',
  8: 'Scorpio',
  9: 'Sagittarius',
  10: 'Capricorn',
  11: 'Aquarius',
  12: 'Pisces'
};